module.exports = __webpack_public_path__ + "static/img/tg1.a5f316e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tg1.png
// module id = qckK
// module chunks = 1